import { sortBy } from 'lodash';
import { computed, makeObservable, observable, toJS, runInAction, action } from 'mobx';
import { buildSelectOptions } from '../../utils/form';

class RequestStore {
  provincesAll = [];
  localitiesAll = [];
  valueModality = 1;
  actualRowId = '';

    data = {
    areas: [],
    subareas: [],
    subareasDataAll: [],

    clients: [],
    subclients: [],
    subclientsDataAll: [],

    c_areas: [],
    c_subAreas: [],
    c_subAreasData: [],
    countries: [],
    employmentModalities: {},
    employmentTypes: {},
    localities: [],
    provinces: [],
    countrylocalities: [],
    nameAccount: '',
    imagePhoto: '',
    typeAccount: '',
    hierarchies: [],
    portalData: []
  };

  constructor() {
    makeObservable(this, {
      data: observable,
      valueModality: observable,
      actualRowId: observable,
      setDataViewRequest: action,
      dataViewRequest: computed,
      formLoaded: false,
      setFormData: action,
      setValueModality: action.bound,
      setActualRowId: action.bound,
      filterLocalities: action.bound,
      filterProvinces: action.bound,
      setAreaSubareas: action.bound,
      resetAreaSubareas: action.bound,
      setClientSubclients: action.bound,
      resetClientSubclients: action.bound
    });
  }

  get dataViewRequest() {
    return toJS(this.data);
  }

  get formLoadedState() {
    return this.formLoaded;
  }

  setFormLoadedState = () => {
    runInAction((loadedState) => {
      this.formLoaded = loadedState;
    });
  };

  setDataViewRequest = (setdata) => {
    runInAction(() => {
      this.data = setdata;
    });
  };

  setItemsByName = (items, name, keyName, keyId) => {
    runInAction(() => {
      this.data[name] = buildSelectOptions(items, keyName, keyId);
    });
  };

  setValueModality = (value) => {
    this.valueModality = value;
  };

  setActualRowId = (value) => {
    this.actualRowId = value;
  };

  filterItemsAll = (value, keyFind, name, keyName, keyId) => {
    const nameAll = `${name}All`;
    const test = toJS(this.data);
    const _items = toJS(test[nameAll]) || [];
    const data = _items.filter((d) => d[keyFind] === value);

    runInAction(() => {
      if (data.length === 0) {
        this.data[name] = [];
      } else {
        this.data[name] = buildSelectOptions(data, keyName, keyId);
      }
    });
  };

  addLocality = (data) => {
    const { id: value } = data;
    runInAction(() => {
      const label = this._buildLabelLocality(data).join(', ');
      const ubi = [...this.data.ubications, { value, label }];
      this.data.ubications = sortBy(ubi, ['label']);
    });
  };

  resetSubarea = () => {
    this.data.c_subAreas = [];
  };

  resetLocalityModal = () => {
    this.data.provinces = [];
    this.data.localities = [];
  };

  updateLocality = (data) => {
    const { id: value } = data;
    runInAction(() => {
      const label = this._buildLabelLocality(data).join(', ');
      const indexUbi = toJS(this.data.ubications).findIndex((u) => u.value === value);
      this.data.ubications[indexUbi].label = label;
      this.data.ubications = sortBy(this.data.ubications, ['label']);
    });
  };

  filterLocalities = (provincefind, customKeyFilter = 'provinceId') => {
    const locaAll = [...toJS(this.localitiesAll)];
    const filters = locaAll.filter((data) => data[customKeyFilter] === provincefind);
    runInAction(() => {
      this.data.localities = buildSelectOptions(filters, 'nombre', 'id', 'provinceId').sort((a, b) =>
        a.label.localeCompare(b.label)
      );
    });
  };

  filterProvinces = (paisFind, customKeyFilter = 'countryId') => {
    const provAll = [...toJS(this.provincesAll)];
    const filters = provAll.filter((data) => data[customKeyFilter] === paisFind);
    runInAction(() => {
      this.data.provinces = buildSelectOptions(filters, 'nombre', 'id', 'countryId').sort((a, b) =>
        a.label.localeCompare(b.label)
      );
      this.data.localities = [];
    });
  };

  setFormData = (data) => {
    this.data.nameAccount = data.nameAccount;
    this.data.imagePhoto = data.imagePhoto;

    this.data.areas = buildSelectOptions(data.areas.items, data.areas.labelField, data.areas.valueField);

    const rawSubs = data?.subareas;
    let subArray = [];
    if (rawSubs?.result === 'success') {
      const payload = rawSubs?.response?.subareas;
      if (Array.isArray(payload)) subArray = payload;
      else if (payload && typeof payload === 'object') subArray = [payload];
    }
    this.data.subareasDataAll = subArray;
    this.data.subareas = [];

    this.data.clients = buildSelectOptions(
      data.clients?.items ?? [],
      data.clients?.labelField ?? 'compañia',
      data.clients?.valueField ?? 'id'
    );

    const rawSubClients = data?.subclients;
    let subClientsArray = [];
    if (rawSubClients?.result === 'success') {
      const payload = rawSubClients?.response?.subclientes;
      if (Array.isArray(payload)) subClientsArray = payload;
      else if (payload && typeof payload === 'object') subClientsArray = [payload];
    }
    this.data.subclientsDataAll = subClientsArray;
    this.data.subclients = [];

    this.data.countries = buildSelectOptions(data.countries.items, 'nombre', 'id');
    this.provincesAll = data.provinces.items;
    this.localitiesAll = data.localities.items;
    this.data.employmentModalities = buildSelectOptions(
      data.employmentModalities.items,
      data.employmentModalities.labelField,
      data.employmentModalities.valueField
    );
    this.data.c_areas = buildSelectOptions(data.c_areas.items, data.c_areas.labelField, data.c_areas.valueField);
    this.data.c_subAreasData = data.c_subAreas.items;

    this.data.hierarchies = buildSelectOptions(
      data.hierarchies.items,
      data.hierarchies.labelField,
      data.hierarchies.valueField
    );
    this.data.portalData = Array.isArray(data.portalData) ? data.portalData : [];

    this.formLoaded = true;
  };

  setSubArea = (areaId) => {
    const subareas = toJS(this.data.c_subAreasData);
    const data = subareas.filter((d) => d.area === areaId);
    runInAction(() => {
      this.data.c_subAreas = buildSelectOptions(data, 'nombre', 'id');
    });
  };

  setAreaSubareas = (areaId) => {
    const all = toJS(this.data.subareasDataAll) || [];
    const filtered = all.filter((s) => s.area === areaId);
    runInAction(() => {
      this.data.subareas = buildSelectOptions(filtered, 'nombre', 'id');
    });
  };

  resetAreaSubareas = () => {
    runInAction(() => {
      this.data.subareas = [];
    });
  };

  setClientSubclients = (clientId) => {
    const all = toJS(this.data.subclientsDataAll) || [];
    const filtered = all.filter((s) => `${s.clienteId}` === `${clientId}`);
    runInAction(() => {
      this.data.subclients = buildSelectOptions(filtered, 'nombre', 'id');
    });
  };

  resetClientSubclients = () => {
    runInAction(() => {
      this.data.subclients = [];
    });
  };
}

export default RequestStore;
